import React from "react";
import { ArrowRight } from "lucide-react";
import styles from "../LandingPage.module.css";

const previewTiles = [
  "Open Interest Ownership",
  "Position Snapshot",
  "% of OI (Crowding)",
  "Change-From (Weekly Shift)",
];

const featureCards = [
  {
    title: "Futures/Option Trends",
    tagline: "Is positioning building, fading, or stretched?",
    body:
      "Weekly trend views show how net, long, and short exposure evolve over time — revealing whether positioning is expanding, unwinding, or reaching crowded extremes.",
  },
  {
    title: "Position vs Price",
    tagline: "Does positioning actually matter here?",
    body:
      "Quantifies whether changes in positioning historically led or lagged price, across different horizons and methods.",
  },
  {
    title: "Trade Setups",
    tagline: "Where price structure offers execution.",
    body:
      "Rule-based intraday pattern detection with explicit triggers, stops, targets, and expiry — no prediction, no signals.",
  },
];

export default function PositioningToExecutionHero() {
  const handleCtaClick = () => {
    const target = document.getElementById("cftc-summary");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className={styles.workflowSection}>
      <div className={styles.workflowGlow} />
      <div className={styles.workflowInner}>
        <div className={styles.workflowHeader}>
          <span className={styles.workflowPill}>60-second read</span>
          <h2 className={styles.workflowTitle}>From Positioning → Context → Execution</h2>
          <p className={styles.workflowQuestion}>
            Where does institutional positioning matter — and where does price offer execution?
          </p>
          <p className={styles.workflowBody}>
            We combine macro positioning, trend context, historical positioning–price relationships, and rule-based intraday
            structure into a single workflow. No predictions. No narratives. Just transparent data, normalized across
            regimes, with explicit rules for execution.
          </p>
        </div>

        <div className={styles.workflowGrid}>
          <div className={styles.workflowPreviewCard}>
            <div className={styles.workflowPreviewPills}>
              <span className={styles.workflowPreviewPill}>CFTC Summary</span>
              <span className={styles.workflowPreviewPill}>6E (Euro FX)</span>
              <span className={styles.workflowPreviewPill}>Weekly</span>
            </div>
            <div className={styles.workflowTileGrid}>
              {previewTiles.map((tile) => (
                <div key={tile} className={styles.workflowTile}>
                  {tile}
                </div>
              ))}
            </div>
            <div className={styles.workflowBottomRow}>Participant Table (Audit)</div>
          </div>

          <div className={styles.workflowCardStack}>
            {featureCards.map((card) => (
              <div key={card.title} className={styles.workflowCard}>
                <div className={styles.workflowCardHeader}>
                  <div>
                    <div className={styles.workflowCardTitle}>{card.title}</div>
                    <div className={styles.workflowCardTagline}>{card.tagline}</div>
                  </div>
                 {/*  <ArrowRight size={18} className={styles.workflowCardIcon} /> */}
                </div>
                <p className={styles.workflowCardBody}>{card.body}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.workflowPreviewImages}>
          <img 
            src="/cftc-trend-preview.png" 
            alt="CFTC Trend Preview" 
            className={styles.workflowPreviewImage}
          />
          <img 
            src="/positioning-price-preview.png" 
            alt="Positioning vs Price Preview" 
            className={styles.workflowPreviewImage}
          />
        </div>

        <div className={styles.workflowValueLine}>
          Institutional positioning for context. Price structure for execution. Nothing in between.
        </div>
        <button className={styles.workflowCta} onClick={handleCtaClick} type="button">
          See How It Works
        </button>
      </div>
    </section>
  );
}
